import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem("clerkToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const fetchRecentSearchedCars = () =>
  axios
    .get(`${BASE_URL}/dashboard/recent-searched-cars`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchRecentRecommendedListings = () =>
  axios
    .get(`${BASE_URL}/dashboard/recent-recommended-listings`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchPopularCars = () =>
  axios
    .get(`${BASE_URL}/dashboard/popular-cars`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchUserDetails = () =>
  axios
    .get(`${BASE_URL}/user/details`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);
